
    <template>
      <section class="relax-doc">
        <h1>快速上手</h1>
<blockquote>
<p>需要先掌握基本的 <code>HTML</code> <code>CSS</code> <code>JavaScript</code>, 如果你已经具备了这些基础，那么你还需要掌握 <code>vue3</code> 的基本用法, 因为<code>RelaxPlus</code>是基于<code>vue3</code></p>
</blockquote>
<h2 id="an-zhuang"><a class="header-anchor" href="#an-zhuang"></a> 安装</h2>
<blockquote>
<p>可以使用 npm 或者 yarn 安装</p>
</blockquote>
<pre><code class="hljs">npm install relaxplus
// or
yarn add relaxplus
</code></pre>
<h2 id="kuai-su-shang-shou"><a class="header-anchor" href="#kuai-su-shang-shou"></a> 快速上手</h2>
<blockquote>
<p>将 relaxplus 注册到 vue 中</p>
</blockquote>
<pre><code class="hljs language-js"><span class="hljs-keyword">import</span> { createApp } <span class="hljs-keyword">from</span> <span class="hljs-string">&#x27;vue&#x27;</span>;
<span class="hljs-keyword">import</span> App <span class="hljs-keyword">from</span> <span class="hljs-string">&#x27;./App.vue&#x27;</span>;
<span class="hljs-keyword">import</span> router <span class="hljs-keyword">from</span> <span class="hljs-string">&#x27;./router&#x27;</span>;

<span class="hljs-comment">// 引入RelaxPlus</span>
<span class="hljs-keyword">import</span> RelaxPlus <span class="hljs-keyword">from</span> <span class="hljs-string">&#x27;relaxplus&#x27;</span>
<span class="hljs-keyword">import</span> <span class="hljs-string">&#x27;relaxplus/lib/relax.css&#x27;</span>

createApp(App)
.use(router)
.use(RelaxPlus) <span class="hljs-comment">// 注册到Vue中</span>
.mount(<span class="hljs-string">&#x27;#app&#x27;</span>)
</code></pre>
<h2 id="liu-lan-qi-zhi-chi"><a class="header-anchor" href="#liu-lan-qi-zhi-chi"></a> 浏览器支持</h2>
<p>仅支持现代浏览器，IE？不存在的！</p>

      </section>
    </template>
    
  